module.exports = __webpack_public_path__ + "media/img/pages/companies/camptocamp-5d5ce4ba36c6b631451fdd18e248c59f.png";